import { createAction, props } from "@ngrx/store";

export const rejectUserDetails = createAction(
  'User.RejectDetails',
  props<{
    error: unknown;
  }>()
);
